import React from 'react';
import { BrainCircuitIcon } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
const steps = [{
  day: 'Día 1',
  title: 'La Primera Sesión',
  description: 'Descubrirás cómo 7 minutos de trabajo olfativo estructurado cansan la mente de tu perro más que una hora de paseo físico.'
}, {
  day: 'Día 7',
  title: 'Cambios Visibles',
  description: 'Notarás que tu perro comienza a elegir el descanso por sí mismo. Los ladridos reactivos disminuyen drásticamente.'
}, {
  day: 'Para Siempre',
  title: 'Calma Duradera',
  description: 'Has reprogramado la respuesta al estrés de tu perro. Ahora tienes un compañero equilibrado y feliz en casa.'
}];
export function MethodSection() {
  return <section className="py-20 px-5 max-w-4xl mx-auto pt-[10px] pb-[10px] space-y-[38px]" data-id="element-119">
      <div className="text-center mb-16" data-id="element-120">
        <FadeInUp data-id="element-121">
          <div className="bg-pistachio/20 border-2 border-pistachio rounded-2xl p-6 md:p-8 mb-12 shadow-sm" data-id="element-122">
            <h2 className="text-2xl md:text-4xl font-serif font-bold text-slate-dark leading-tight" data-id="element-123">
              La calma no se trata de pasear más. Se trata de{' '}
              <span className="text-green-700 underline decoration-4 underline-offset-4" data-id="element-124">
                REPROGRAMAR
              </span>{' '}
              el cerebro de tu perro.
            </h2>
          </div>
        </FadeInUp>

        <FadeInUp delay={0.1} data-id="element-125">
          <span className="inline-block text-pistachio font-bold tracking-wider text-sm mb-4" data-id="element-126">
            EL MÉTODO
          </span>
        </FadeInUp>
        <FadeInUp delay={0.2} data-id="element-127">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-slate-dark mb-6" data-id="element-128">
            Estimulación Cognitiva vs. Cansancio Físico
          </h2>
        </FadeInUp>

        <FadeInUp delay={0.25} data-id="element-129">
          <div className="inline-flex items-center gap-3 bg-slate-dark text-white px-6 py-3 rounded-full mb-6 shadow-lg" data-id="element-130">
            <BrainCircuitIcon className="w-6 h-6 text-pistachio" data-id="element-131" />
            <span className="font-bold tracking-wide text-sm uppercase" data-id="element-132">
              La Ciencia Detrás
            </span>
          </div>
        </FadeInUp>

        <FadeInUp delay={0.3} data-id="element-133">
          <p className="text-lg text-slate-dark/80 max-w-2xl mx-auto" data-id="element-134">
            Muchos dueños creen que la solución a la ansiedad es correr hasta el
            agotamiento. La ciencia demuestra que el trabajo mental enfocado
            reduce los niveles de cortisol mucho más rápido.
          </p>
        </FadeInUp>

        <FadeInUp delay={0.35} data-id="element-135">
          <p className="mt-6 text-lg md:text-xl font-serif font-semibold text-green-700 bg-pistachio/15 border border-pistachio/30 rounded-2xl px-6 py-4 max-w-2xl mx-auto" data-id="element-136">
            Estás a 7 minutos de recuperar la paz de tu hogar sin gastar $40.000
            en adiestradores.
          </p>
        </FadeInUp>
      </div>

      <div className="relative border-l-2 border-zen-beige ml-4 md:ml-8 space-y-12 pb-8" data-id="element-137">
        {steps.map((step, index) => <FadeInUp key={index} delay={index * 0.15} className="relative pl-8 md:pl-12" data-id="element-138">
            <div className="absolute -left-[17px] top-1 w-8 h-8 rounded-full bg-pistachio border-4 border-white flex items-center justify-center shadow-sm" data-id="element-139">
              <div className="w-2 h-2 rounded-full bg-slate-dark" data-id="element-140" />
            </div>
            <div className="bg-white border border-zen-beige p-6 rounded-3xl shadow-sm" data-id="element-141">
              <span className="text-sm font-bold text-slate-dark/50 uppercase tracking-wider mb-2 block" data-id="element-142">
                {step.day}
              </span>
              <h3 className="text-xl font-bold text-slate-dark mb-3" data-id="element-143">
                {step.title}
              </h3>
              <p className="text-slate-dark/70 leading-relaxed" data-id="element-144">
                {step.description}
              </p>
            </div>
          </FadeInUp>)}
      </div>
    </section>;
}